<template>

    <div class="text-center">

        <div class="row no-gutters align-items-center">

            <slot name="pager-column-before"></slot>

            <div class="text-portal-dark-grey" v-show="totalNumberOfPages > 1" v-bind:class="columnCssToRender">
                <i class="fas fa-chevron-left mr-2" aria-label="Go to previous page" @click="onIconPageChange(currentPage-1)" v-bind:class="{ 'text-portal-grey disable-while-loading' : isFirstPage, 'text-portal-primary-blue c-pointer': !isFirstPage }"></i>
                <span class="mr-2">{{pageText}}</span>
                <input type="text" maxlength="3" aria-label="Go to a specific page" v-bind:class="{ 'is-invalid pager-validation': !hasValidPageNumber }" class="form-control d-inline-block mr-2 text-center pager-input" v-model.number="freeTextPageValue" v-on:keyup="freeTextEdit" />
                <span class="mr-2 ">{{pageOfText}} {{totalNumberOfPages}}</span>

                <i class="fas fa-chevron-right text-portal-primary-blue" aria-label="Go to next page" @click="onIconPageChange(currentPage+1)" v-bind:class="{ 'text-portal-grey disable-while-loading' : isLastPage, 'text-primary c-pointer': !isLastPage }"></i>
            </div>

            <slot name="pager-column-after"></slot>
        </div>
    </div>

</template>

<script>

    import './generic.pager.scss';
    import { ResolveStaticContent } from '@SharedServices/localization.service';

    export default {
        name: 'pager',
        props: {
            recordsPerPage: { type: Number },
            currentPage: { type: Number },
            fullDataSet: { type: Array },
            pagerColumnCss: { type: Object },
            pageText: { type: String, default: ResolveStaticContent('PagerPageText') }, //can flip to this when all pages that use the grid are translated
            pageOfText: { type: String, default: ResolveStaticContent('PagerPageOfText') } //can flip to this when all pages that use the grid are translated
        },
        data: function () {
            return {
                //holds the timer for the lazy typing
                timer: null,
                freeTextPageValue: this.currentPage
            }
        },
        mounted: function () {
            this.pagerIsVisible();
        },
        computed: {

            columnCssToRender: function () {
                if (this.pagerColumnCss) {
                    return this.pagerColumnCss;
                }

                return { 'col': true };
            },

            hasValidPageNumber: function () {

                let parseIntResult = parseInt(this.freeTextPageValue, 10);

                return this.freeTextPageValue && !isNaN(parseIntResult) ?
                    this.validPageIds.indexOf(parseIntResult) > -1 :
                    false;
            },

            validPageIds: function () {
                let pageIds = [];
                let totalPages = this.totalNumberOfPages;

                for (var i = 0; i < totalPages; i++) {
                    pageIds.push(i + 1);
                }

                return pageIds;
            },

            totalNumberOfPages: function () {

                let numberOfPages = Math.ceil(this.fullDataSet.length / this.recordsPerPage);

                this.$emit('total-number-of-pages-change', numberOfPages);

                return numberOfPages;
            },

            isFirstPage: function () {
                return this.currentPage == 1;
            },

            isLastPage: function () {
                return this.currentPage == this.totalNumberOfPages;
            }

        },
        watch: {

            currentPage: function (newValue, oldValue) {
                this.freeTextPageValue = newValue;
            },

            totalNumberOfPages: function (newValue, oldValue) {
                this.pagerIsVisible();
            }

        },
        methods: {

            pagerIsVisible: function () {
                this.$emit('pagerIsVisible', this.totalNumberOfPages > 1);
            },

            freeTextEdit: function ($evt) {
                //this just waits a few milliseconds when you type something
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    if (this.hasValidPageNumber) {
                        this.$emit("change", parseInt(this.freeTextPageValue), this.$el.id);
                    }
                }, 1000);
            },

            onIconPageChange: function (gotoPage) {
                this.$emit("change", gotoPage, this.$el.id);
            }
        }
    };

</script>

